import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants.type';

const changeUser = async (uuid: string) => {
  const url = `${import.meta.env.VITE_AUTH_SERVICE_HOST}/v1/admin/users/${uuid}/signin`;

  return request({ url, method: RequestMethod.GET });
};

export const useChangeUser = ({ uuid, options }: { uuid: string; options?: Record<string, boolean | number> }) => {
  return useGenericQuery<{ accessToken: string; refreshToken: string }, RequestError>(
    // The uuid belongs in the key: without it a second pick inside the 10s stale window is served
    // the first user's credentials from cache, and the admin impersonates the wrong person.
    [QUERY_KEYS.changeUser, uuid],
    () => changeUser(uuid),
    {
      ...options,
      // No cache retention: a rolled-back or errored attempt must leave nothing behind, or a retry
      // of the same user would replay the stale result on its first render, before the refetch lands
      // — impersonating on a cached error, or on a previous person's credentials.
      gcTime: 0,
      enabled: !!uuid && !!options?.enabled,
    }
  );
};
